module.exports = __webpack_public_path__ + "static/media/snappy-attendant.4879de3b.svg";